export const openPackageDetails = (packageId: number) => {
  window.location.assign(`/order/${packageId}?type=package`);
};
